export const PXGlossaryCards = (function () {
	'use strict';

	function init() {
		const filterEls = document.querySelectorAll('[js-glossary-filter]')
		const searchEl = document.querySelector('[js-glossary-search]')
		const resetEl = document.querySelector('[js-glossary-reset]')
		const cardEls = document.querySelectorAll('[js-glossary-card]')
		const stickyEl = document.querySelector('[js-glossary-sticky]')
		if (!filterEls.length || !cardEls.length) {
			return
		}

		const updateButtons = () => {
			filterEls.forEach((button) => {
				button.classList.remove('active')
			})
			cardEls.forEach((card) => {
				if (!card.classList.contains('hide')) {
					const letter = card.getAttribute('data-letter')
					const button = document.querySelector(`[js-glossary-filter="${letter}"]`)
					button.classList.add('active')
				}
			})
		}

		const scrollTo = (letter) => {
			const card = document.querySelector(`[js-glossary-card^="${letter}" i]`)
			const stickyHeight = stickyEl.getBoundingClientRect().height
			window.scrollTo({
				top: Math.ceil(card.getBoundingClientRect().top + document.documentElement.scrollTop) - 120 - stickyHeight,
				behavior: 'smooth',
			})
		}

		const eachCardToggle = (hideCB) => {
			cardEls.forEach((card) => {
				card.classList.toggle('hide', hideCB ? hideCB(card) : false)
			})
		}

		const search = (searchTerm) => {
			searchTerm = searchTerm.toLowerCase()
			eachCardToggle((card) => {
				return !card.getAttribute('js-glossary-card').toLowerCase().includes(searchTerm)
			})
		}

		const onSearchInput = (ev) => {
			if (searchEl.value.length > 2) {
				search(searchEl.value)
			} else {
				eachCardToggle()
			}
			updateButtons()
		}

		const onResetClick = (ev) => {
			ev.preventDefault()
			ev.stopPropagation()
			searchEl.value = ""
			eachCardToggle()
			updateButtons()
		}

		searchEl.addEventListener('input', onSearchInput)
		resetEl.addEventListener('click', onResetClick)

		filterEls.forEach((button) => {
			const letter = button.getAttribute('js-glossary-filter')
			button.addEventListener('click', event => scrollTo(letter))
		})

		updateButtons()
	}

	return {
		init: init
	};
})();
